import { render, staticRenderFns } from "./institutionalAnalysis.vue?vue&type=template&id=395b71d1&scoped=true&"
import script from "./institutionalAnalysis.vue?vue&type=script&lang=js&"
export * from "./institutionalAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./institutionalAnalysis.vue?vue&type=style&index=0&id=395b71d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395b71d1",
  null
  
)

export default component.exports